import NFA from 'shared/helpers/analytics/NFAnalytics';

export const canShowPDPMeasurements = (config?: string) => config === 'true';

interface SizeTrackingData {
  selectedSizesList: string[];
  selectedSize: string;
  variantProductID: string;
  catalog_tag?: string[];
  catalogTagFilter?: string;
  interactionLocation?: string;
}
export const trackSizeSelection = (sizeTrackingData: SizeTrackingData) => {
  const { catalog_tag, catalogTagFilter, interactionLocation, ...rest } = sizeTrackingData;
  NFA.track({
    event: 'product_size_clicked',
    data: {
      ...rest,
      sizeSelectionCount: sizeTrackingData?.selectedSizesList?.length,
      ...(catalog_tag ? { catalog_tags: catalog_tag } : {}),
      ...(catalogTagFilter ? { catalog_tag_filter: catalogTagFilter } : {}),
      ...(interactionLocation ? { interaction_location: interactionLocation } : {}),
    },
  });
};
